module.exports = __webpack_public_path__ + "img/silver9.43171031.gif";